define.alias("shared/utils/array-filters/get-first-point-by-name", "preview-grid/utils/array-filters/get-first-point-by-name");